var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7083 3.55791C10.8933 3.55791 12.6666 5.31409 12.6666 7.47796C12.6666 7.98757 12.5637 8.46581 12.3816 8.9127L14.6933 11.202C15.8887 10.2142 16.8308 8.93622 17.4087 7.47796C16.0391 4.03616 12.6587 1.59789 8.70039 1.59789C7.59206 1.59789 6.53123 1.79389 5.54956 2.1467L7.25956 3.84016C7.71081 3.65983 8.19372 3.55791 8.7083 3.55791ZM0.791664 1.41757L2.59666 3.20511L2.96082 3.56575C1.64666 4.57713 0.617498 5.92562 0 7.47796C1.36958 10.9198 4.74998 13.358 8.7083 13.358C9.93538 13.358 11.107 13.1228 12.1758 12.6995L12.5083 13.0287L14.8279 15.3181L15.8333 14.3224L1.79708 0.421875L0.791664 1.41757ZM5.16957 5.75314L6.39665 6.96835C6.35706 7.133 6.33331 7.30548 6.33331 7.47796C6.33331 8.77942 7.39414 9.82999 8.7083 9.82999C8.88247 9.82999 9.05664 9.80647 9.22289 9.76727L10.45 10.9825C9.91955 11.2412 9.33372 11.398 8.7083 11.398C6.52331 11.398 4.74998 9.64183 4.74998 7.47796C4.74998 6.85859 4.90832 6.27843 5.16957 5.75314ZM8.58164 5.14161L11.0754 7.61124L11.0912 7.4858C11.0912 6.18434 10.0304 5.13377 8.71622 5.13377L8.58164 5.14161Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeIcon);
export default __webpack_public_path__ + "static/media/PasswordEyeIcon.4834d4df3ee117814e2e2bc8ce25afa9.svg";
export { ForwardRef as ReactComponent };